<script>
	export let key;

    function onClick(e) {
        console.log("Clicked: " + key);
        document.dispatchEvent(new KeyboardEvent("keydown", {
            key: key.toLowerCase(),
        }));
    }
</script>

<div on:pointerdown={onClick}>
    <span>{key}</span>
</div>

<style>
    div {
        background-color: rgb(17, 134, 80);;
        width:100%;
        border-left: solid 3px rgb(6, 201, 110);
        display: flex;
        justify-content: center;
        align-items: center;
        user-select: none;
    }

    span {
        color:white;
        font-weight: bold;
        font-size: 22px;
        user-select: none;
    }

    @media (hover: none){
        span {
            display: none;
            visibility: hidden;
        }
        /* touch stuff goes here */
    }
</style>